export enum LEVEL_ROL {
  ADMIN = 1,
  DIRECTOR = 2,
  USER = 3,
}
